<script>
  import {Input, InputGroup, Container, Row, Col, InputGroupText, Button} from "sveltestrap";
  import CellRef from '../crud/cell-types/cell-ref.svelte';
  import Invoice from './invoice.svelte';
  import {createRecord} from "../../modules/api-client";
  import {getHtmlInvoice} from "../../modules/api-client";
  import {getInvoice} from "../../modules/api-client";

  let customer = {_id: "622b28f1e68b8910f3243c36", name: "Scopely"};
  let year = new Date().getFullYear();
  let month = new Date().getMonth() + 1;
  let invoice;
  let htmlInvoice;

  async function calculate() {
    invoice = await getInvoice(year, month, customer._id);
    htmlInvoice = await getHtmlInvoice(year, month, customer._id);
  }

  async function create() {
    return createRecord('invoices', invoice);
  }

  calculate();

</script>


<div class="container-fluid">
    <!-- Page Heading -->
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">Dashboard</h1>
        <div>
            <a href="#" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm" on:click={calculate}>
                <i class="bi bi-arrow-clockwise"></i> Calculate</a>
            <a href="#" class="d-none d-sm-inline-block btn btn-sm btn-primary shadow-sm" on:click={create}>
                <i class="bi bi-receipt"></i> Create</a>
        </div>
    </div>

    <!-- Content Row -->
    <div class="row">
        <Row>
            <Col>
                <InputGroup>
                    <InputGroupText>Month</InputGroupText>
                    <Input type="number" bind:value={month}/>
                </InputGroup>
            </Col>
            <Col>
                <InputGroup>
                    <InputGroupText>Year</InputGroupText>
                    <Input type="number" bind:value={year}/>
                </InputGroup>
            </Col>
            <Col>
                <InputGroup>
                    <InputGroupText>Customer</InputGroupText>
                    <CellRef ref="customers" bind:value={customer}/>
                </InputGroup>
            </Col>
        </Row>
        <Row>
            <iframe class="invoice" srcdoc="{htmlInvoice}"></iframe>
        </Row>
        <Row>
            <Invoice invoice={invoice}/>
        </Row>
    </div>
</div>

<style>
    .invoice {
        height: 60em;
    }
</style>
